export const TrixelSourceCategories = {
  AddressProfilePageReviewTile: 'RateMyAgent:AddressProfile:ReviewsTile',
  AddressProfilePageCampaignTile: 'RateMyAgent:AddressProfile:CampaignTile',
  AddressProfilePageSpotlightTile: 'RateMyAgent:AddressProfile:SpotlightTile',
  AgencyProfileContactForm: 'RateMyAgent:AgencyProfile:ContactForm',
  AgencyProfilePage: 'RateMyAgent:AgencyProfile:View',
  AgencyProfilePageReviewTile: 'RateMyAgent:AgencyProfile:ReviewsTile',
  AgencyProfilePageCampaignTile: 'RateMyAgent:AgencyProfile:CampaignTile',
  AgentProfileContactForm: 'RateMyAgent:AgentProfile:ContactForm',
  AgentProfilePage: 'RateMyAgent:AgentProfile:View',
  AgentProfilePageCampaignTile: 'RateMyAgent:AgentProfile:CampaignTile',
  AgentProfilePageReviewTile: 'RateMyAgent:AgentProfile:ReviewsTile',
  CampaignListingPage: 'RateMyAgent:CampaignListing:View', // RateMyAgent:ListingPage:DetailedListingPage
  CampaignListingPageContactForm: 'RateMyAgent:CampaignListing:ContactForm',
  CampaignListingPageCampaignTile: 'RateMyAgent:CampaignListing:CampaignTile',
  FindMyAgentResultsView: 'RateMyAgent:FindMyAgent:ResultsView',
  HomePageReviewTile: 'RateMyAgent:PublicHomePage:ReviewsTile',
  LandingPageFeaturedReview: 'RateMyAgent:LandingPage:FeaturedReview',
  LocationPageFeaturedReview: 'RateMyAgent:LocationPage:FeaturedReview',
  LocationPageReviewTile: 'RateMyAgent:LocationPage:ReviewsTile',
  LocationPageCampaignTile: 'RateMyAgent:LocationPage:CampaignTile',
  LocationProfileAgencyTile: 'RateMyAgent:LocationProfile:AgencyProfileTile',
  LocationProfileAgentTile: 'RateMyAgent:LocationProfile:AgentProfileTile',
  LocationProfileReveal: 'RateMyAgent:LocationProfile:Reveal',
  LocationProfileCall: 'RateMyAgent:LocationProfile:Call',
  LocationProfileContactForm: 'RateMyAgent:LocationProfile:ContactForm',
  MapCampaignTile: 'RateMyAgent:Map:CampaignTile',
  MapContactForm: 'RateMyAgent:Map:ContactForm',
  MapReviewTile: 'RateMyAgent:Map:ReviewsTile',
  MarketReport: 'RateMyAgent:MarketReport:View',
  ProfilePropertiesPageCampaignTile: 'RateMyAgent:ProfileProperties:CampaignTile',
  ProfilePropertiesPageContactForm: 'RateMyAgent:ProfileProperties:ContactForm',
  ProfileReviewsPageTile: 'RateMyAgent:ProfileReviews:ReviewsTile',
  ProfileReviewsPageContactForm: 'RateMyAgent:ProfileReviews:ContactForm',
  ReviewDetail: 'RateMyAgent:ReviewPage:DetailedReviewPage',
} as const;

export type TrixelSourceCategory = (typeof TrixelSourceCategories)[keyof typeof TrixelSourceCategories];
